import { useEffect, useState } from 'react';
import fetchVulnToolsHistory from '../api/fetchVulnToolsHistory';
import parseToolsHistory from './parseToolsHistory';

const EMPTY_STATE = { vulnId: null, items: [] };

/**
 * Loads the tools history of a vulnerability and reloads it whenever the vulnerability changes.
 *
 * @param {string} workspaceName - Workspace the vulnerability belongs to.
 * @param {number} vulnId - Vulnerability id.
 * @returns {{items: Array<{tool: string, commandId: number, createDate: string}>, isLoaded: boolean}}
 *   `isLoaded` only turns true once the history of the current `vulnId` arrived (or failed).
 */
const useVulnToolsHistory = (workspaceName, vulnId) => {
  const [history, setHistory] = useState(EMPTY_STATE);

  useEffect(() => {
    if (!workspaceName || !vulnId) return undefined;

    let isCurrentRequest = true;
    const settle = (items) => {
      if (isCurrentRequest) setHistory({ vulnId, items });
    };

    fetchVulnToolsHistory(workspaceName, vulnId)
      .then((response) => settle(parseToolsHistory(response)))
      .catch(() => settle([]));

    return () => { isCurrentRequest = false; };
  }, [workspaceName, vulnId]);

  const isLoaded = history.vulnId === vulnId;

  return { items: isLoaded ? history.items : [], isLoaded };
};

export default useVulnToolsHistory;
